import Link from 'next/link';

import { Hero } from '@components/Hero/Hero';
import Button from '@common/Button/Button';
import Icon from '@common/Icons/Icon';

type Props = {
  title: string;
  description: string;
  href: string;
  image: string;
};

export const LatestStoryHero = ({
  title,
  description,
  href,
  image,
}: Props): JSX.Element => (
  <Hero
    image={image}
    altText={title}
    title={<span className="text-blue">{title}</span>}
    description={<span className="text-blue">{description}</span>}
    supertitle={<span className="text-purple-200">Latest story</span>}
    color="bg-purple"
    isColourBlockImage
    priority
    ctaChildren={
      <Link href={href} key="read-button">
        <Button
          colour="NavyBlue"
          type="Primary"
          fullWidth={false}
          icon={<Icon name="rightArrow" />}
        />
      </Link>
    }
  />
);
